// client\src\index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import "./course/styles/OverStyles.css";
import { HelmetProvider } from "react-helmet-async";

import App from './App.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
